"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SubMenu;
var _react = _interopRequireWildcard(require("react"));
var _beam = require("beam");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useStyles = (0, _beam.makeStyles)(() => ({
  root: {
    flexGrow: 1,
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translateX(100%)',
    '&.expand-left': {
      right: 'unset',
      left: 0,
      transform: 'translateX(-100%)'
    }
  },
  subMenuItem: {
    fontSize: 14
  }
}));
function SubMenu({
  menuItems
}) {
  const classes = useStyles();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const subMenuWrapper = /*#__PURE__*/(0, _react.createRef)();
  const [overflow, setOverflow] = (0, _react.useState)(false);
  const renderChildItems = items => {
    return items.flat().map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.MenuItem, {
      className: classes.subMenuItem,
      component: 'a',
      href: item.url,
      target: item.external ? '_blank' : undefined,
      rel: item.external ? 'noopener' : undefined,
      "auto-qa-id": `OverflowMenu-SubMenu-${item.key}`,
      "data-testid": `OverflowMenu-SubMenu-${item.key}`,
      children: t(item.key)
    }, item.key));
  };

  // useLayoutEffect is a more accurate replacement for component did mount than useEffect
  // https://reacttraining.com/blog/useEffect-is-not-the-new-componentDidMount/
  (0, _react.useLayoutEffect)(() => {
    if (subMenuWrapper.current) {
      const rect = subMenuWrapper.current.getBoundingClientRect();
      setOverflow(rect.right > window.innerWidth);
    }
  }, []);
  const rootClasses = classes.root + (overflow ? ' expand-left' : '');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: rootClasses,
    ref: subMenuWrapper,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.Paper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_beam.MenuList, {
        children: renderChildItems(menuItems)
      })
    })
  });
}
//# sourceMappingURL=SubMenu.js.map